// CDV-022: render a `kpi` block — single big number, eyebrow label,
// optional unit / trend glyph / caption.

interface Props { //@usedby:ComposedBody.tsx
  label: string
  value: string | number
  unit?: string
  trend?: 'up' | 'down' | 'flat'
  caption?: string
}

const TREND_GLYPH: Record<NonNullable<Props['trend']>, string> = {
  up: '↑',
  down: '↓',
  flat: '→',
}

export function KpiBlockView({ label, value, unit, trend, caption }: Props) {
  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <div className="text-xs uppercase tracking-wider text-foreground-muted">{label}</div>
      <div className="mt-1 flex items-baseline gap-2">
        <span className="text-3xl font-semibold tabular-nums text-foreground">
          {value}
        </span>
        {unit ? <span className="text-sm text-foreground-muted">{unit}</span> : null}
        {trend ? (
          <span
            aria-label={`trend ${trend}`}
            className="text-base text-foreground-muted"
          >
            {TREND_GLYPH[trend]}
          </span>
        ) : null}
      </div>
      {caption ? (
        <div className="mt-1 text-xs text-foreground-muted">{caption}</div>
      ) : null}
    </div>
  )
}
